import { clampTemperatureText } from 'src/models/Reaction';

const setReactionByType = (reaction, type, value) => {
  let options = {};

  switch (type) {
    case 'name':
      reaction.name = value;
      break;
    case 'observation':
      reaction.observation = value;
      break;
    case 'status':
      reaction.status = value;
      break;
    case 'reactionType':
      reaction.reaction_type = value;
      if (value === 'interaction') {
        reaction.gaseous = false;
        reaction.weight_percentage = false;
      }
      options = { updateGraphic: true };
      break;
    case 'description':
      reaction.description = value;
      break;
    case 'purification':
      reaction.purification = value;
      break;
    case 'tlc_solvents':
      reaction.tlc_solvents = value;
      break;
    case 'rfValue':
      reaction.rf_value = value;
      break;
    case 'timestampStart':
      reaction.timestamp_start = value;
      break;
    case 'timestampStop':
      reaction.timestamp_stop = value;
      break;
    case 'tlcDescription':
      reaction.tlc_description = value;
      break;
    case 'temperature':
      reaction.temperature.userText = clampTemperatureText(value, reaction.temperature.valueUnit);
      options = {updateGraphic: true}
      break;
    case 'temperatureUnit':
      reaction.temperature = reaction.convertTemperature(value);
      options = {updateGraphic: true}
      break;
    case 'temperatureData':
      reaction.temperature = value;
      options = {updateGraphic: true}
      break;
    case 'dangerousProducts':
      reaction.dangerous_products = value;
      break;
    case 'conditions':
      reaction.conditions = value;
      options = {updateGraphic: true}
      break;
    case 'phOperator':
      reaction.ph_operator = value;
      break;
    case 'phValue':
      reaction.ph_value = value;
      break;
    case 'solvent':
      reaction.solvent = value;
      options = {updateGraphic: true}
      break;
    case 'role':
      reaction.role = value;
      reaction.name = reaction.nameFromRole(value);
      break;
    case 'duration':
      reaction.durationDisplay = value;
      options = { updateGraphic: true }
      break;
    case 'rxno':
      reaction.rxno = value;
      break;
    case 'vesselSizeAmount':
      reaction.vessel_size.amount = value;
      break;
    case 'vesselSizeUnit':
      reaction.vessel_size.unit = value;
      if (value === 'ml') {
        reaction.vessel_size.amount = reaction.vessel_size.amount * 1000;
      } else if (value === 'l') {
        reaction.vessel_size.amount = reaction.vessel_size.amount / 1000;
      }
      break;
    case 'gaseous':
      reaction.gaseous = value;
      break;
    case 'volume':
      reaction.volume = value;
      break;
    case 'concentrationMode':
      reaction.concentration_mode = value;
      break;
    case 'lockReactionVolume':
      reaction.lock_reaction_volume = value;
      break;
    case 'weight_percentage':
      reaction.weight_percentage = value;
      break;
  }

  return { newReaction: reaction, options: options }
}

export {setReactionByType}
